import NavItem from "./NavItem";
import { useLocation } from "react-router-dom";
import { IMAGES } from "../constants/images";
import { ICONS } from "../constants/icons";
import MobileBottomNav from "./MobileBottomNav";
import { FiLogOut } from "react-icons/fi";
import { BsBriefcase } from "react-icons/bs";
import { LuTrendingUp, LuSend, LuTrophy, LuDollarSign } from "react-icons/lu";
import { useUser } from "../contexts/UserContext";
import { ROUTES } from "../App";
import useUnreadMessages from "../hooks/useUnreadMessages";
import useUnreadActivityCount from "../hooks/useUnreadActivityCount";

const Sidebar = () => {
    const { openLogoutModal, currentUser } = useUser();
    const location = useLocation();
    const unreadCount = useUnreadMessages(); // Custom hook to get unread messages count
    const activityUnreadCount = useUnreadActivityCount(); // Custom hook to get unread activity count
    const showVerificationMarker = Boolean(currentUser);

    const isPreview = location.pathname.includes("/preview/");
    if (isPreview && !currentUser) return null;

    return (
        <>
            <aside className="hidden h-screen w-52 pt-10 pb-6 px-6 md:flex flex-col space-y-2 bg-[#f4f4f4] text-black dark:bg-[#242424] dark:text-white transition-colors duration-200">
                {/* Logo */}
                <div className="mb-6 flex justify-center">
                    <img
                        src={IMAGES.dashboardLogo}
                        alt="Logo"
                        className="dashboard-logo brightness-0 dark:invert"
                    />
                </div>

                {/* Menu Items */}
                <NavItem
                    icon={ICONS.home}
                    label="Home"
                    to={ROUTES.DASHBOARD}
                    activePaths={[ROUTES.DASHBOARD, ROUTES.COMMUNITY_SEARCH, ROUTES.COMMUNITY_CHAT, ROUTES.APPLY_CHALLENGE]}
                />

                <NavItem
                    icon={ICONS.studio}
                    label="Studio"
                    to={ROUTES.STUDIO}
                    activePaths={[ROUTES.STUDIO, ROUTES.MY_COMMUNITY, ROUTES.SUBSCRIPTION_PLAN, ROUTES.NEW_COMMUNITY, ROUTES.MY_PRODUCTS, ROUTES.ADD_PRODUCT, ROUTES.ADD_COURSE, ROUTES.ADD_CHAPTER, ROUTES.MANAGE_CHAPTER, ROUTES.CHAPTER_CONTENT, ROUTES.ADD_LESSON]}
                />
                <NavItem
                    icon={ICONS.store}

                    label="Library"
                    to={ROUTES.STORE}
                    activePaths={[ROUTES.STORE, ROUTES.MY_LIBRARY, ROUTES.STORE_COURSES, ROUTES.PRODUCT_DETAILS, ROUTES.CHAPTERS, ROUTES.LESSONS_IN_CHAPTER, ROUTES.VIEW_LESSON]}
                />
                <NavItem
                    icon={ICONS.chat}
                    label="Chat"
                    to={ROUTES.CHATS}
                    activePaths={[ROUTES.CHATS, ROUTES.PRIVATE_USER_CHAT, ROUTES.CREATE_GROUP, ROUTES.GROUP_CHAT]}
                    unreadCount={unreadCount}
                />
                <NavItem
                    ReactIcon={BsBriefcase}
                    label="Jobs"
                    to={ROUTES.JOBS_FIND}
                    exactActivePaths={[ROUTES.JOBS]}
                    activePaths={[ROUTES.JOBS_FIND, ROUTES.JOBS_POST, ROUTES.JOBS_APPLY, ROUTES.JOBS_MY_POSTS, ROUTES.JOBS_APPLICANTS]}
                />
                {currentUser?.isAdmin && (
                    <>
                        <NavItem
                            ReactIcon={LuTrendingUp}
                            label="Analytics"
                            to={ROUTES.ADMIN_ANALYTICS}
                            activePaths={[ROUTES.ADMIN_ANALYTICS]}
                        />
                        <NavItem
                            ReactIcon={LuSend}
                            label="Broadcast"
                            to={ROUTES.ADMIN_BROADCAST}
                            activePaths={[ROUTES.ADMIN_BROADCAST]}
                        />
                        <NavItem
                            ReactIcon={LuDollarSign}
                            label="Payouts"
                            to={ROUTES.ADMIN_PAYOUTS}
                            activePaths={[ROUTES.ADMIN_PAYOUTS]}
                        />
                        <NavItem
                            ReactIcon={LuTrophy}
                            label="Challenges"
                            to={ROUTES.ADMIN_CHALLENGES}
                            activePaths={[ROUTES.ADMIN_CHALLENGES]}
                        />
                    </>
                )}
                <NavItem
                    icon={ICONS.profile}
                    label="Profile"
                    to={ROUTES.PROFILE}
                    activePaths={[ROUTES.PROFILE, ROUTES.EDIT_PROFILE, ROUTES.SETTINGS, ROUTES.DELETE_ACCOUNT, ROUTES.ACCOUNT_ACTIVITY, ROUTES.CREATE_CHALLENGE]}
                    unreadCount={activityUnreadCount}
                />

                {/* Logout */}
                {
                    currentUser && (
                        <>
                            <button
                                onClick={openLogoutModal}
                                className="flex items-center space-x-3 py-3 px-4 rounded-lg transition-all duration-200 hover:bg-gray-100 dark:hover:bg-white/10 opacity-80"
                            >
                                <FiLogOut className="w-5 h-5 text-black opacity-70 dark:text-white dark:opacity-80" />
                                <span className="text-base font-medium">Logout</span>
                            </button>

                            {showVerificationMarker && (
                                <div className="flex justify-center pt-2" aria-hidden="true">
                                    <span
                                        className="inline-block h-1.5 w-1.5 rounded-full bg-emerald-500/70 dark:bg-emerald-400/80"
                                        title="Live verification marker"
                                    />
                                </div>
                            )}
                        </>
                    )
                }
            </aside>

            {/* Mobile nav */}
            <MobileBottomNav />
        </>
    );
};

export default Sidebar;
